import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Website Coming Soon
        </p>
      </header>
    </div>
  );
}

export default App;
